module.exports = __webpack_public_path__ + "img/Score-Cards_01.1739b068.png";